<script>
import { Bar } from "vue-chartjs";
import moment from "moment";
moment.locale("de-de");

export default {
  extends: Bar,
  name: "LizenzChart",
  props: {
    chartdata: {
      type: Array,
      default: null
    },
    options: {
      type: Object,
      default: null
    },
    chartValues: {
      type: Array,
      default: null
    }
  },

  computed: {
    labels() {
      let labels = [];
      if (!this.chartdata) {
        return labels;
      }
      for (let item of this.chartdata) {
        labels.push(
          moment()
            .month(item.month)
            .format("MMMM")
        );
      }
      return labels;
    },
    datasets() {
      let amount = {
        label: "Tellergerichte",
        data: [],
        backgroundColor: "#218916"
      };
      let fee = {
        label: "Gebühren in Euro",
        data: [],
        backgroundColor: "#efae45"
      };

      if (!this.chartdata) {
        return [];
      }
      for (let item of this.chartdata) {
        amount.data.push(item.totalAmount);
        fee.data.push(item.feeCent / 100);
      }
      let ds = [];
      if (this.chartValues && this.chartValues.indexOf("amount") >= 0) {
        ds.push(amount);
      }
      if (this.chartValues && this.chartValues.indexOf("fee") >= 0) {
        ds.push(fee);
      }
      if (!this.chartValues) {
        ds = [amount, fee];
      }

      return ds;
    }
  },
  mounted() {
    this.renderChart(
      {
        labels: this.labels,
        datasets: this.datasets
      },
      this.options
    );
  }
};
</script>

<style></style>
